var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8973_8692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 0.667969H2.66536C1.93203 0.667969 1.33203 1.26797 1.33203 2.0013V11.3346H2.66536V2.0013H10.6654V0.667969ZM12.6654 3.33464H5.33203C4.5987 3.33464 3.9987 3.93464 3.9987 4.66797V14.0013C3.9987 14.7346 4.5987 15.3346 5.33203 15.3346H12.6654C13.3987 15.3346 13.9987 14.7346 13.9987 14.0013V4.66797C13.9987 3.93464 13.3987 3.33464 12.6654 3.33464ZM12.6654 14.0013H5.33203V4.66797H12.6654V14.0013Z",
    fill: "#9FBFE5",
    fillOpacity: 0.996078
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8973_8692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPurple);
export default __webpack_public_path__ + "static/media/copy-purple.6c76b859898519fb00d4976af979832e.svg";
export { ForwardRef as ReactComponent };